var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-navbar theme2-bg has-text-centered"},[_c('h1',{staticClass:"title"},[_vm._v("Gestor de Processos")])])}]

export { render, staticRenderFns }